import Toaster from '@/@core/utils/sweetToast'
import api from '@/plugins/apiService'

export default {
  namespaced: true,
  state: {
    folderIds: {
      Plans: '',
      Photos: '',
      Files: '',
      Specifications: '',
    },
    projectInfo: {},
    showActivityBar: false,
    isStartDrawing: false,
    toolType: 0,
    visualData: null,
    compareVisualData: {},
    visualCount: 0,
    showColorBox: false,
    selectedObjectName: null,
    isSelectObject: false,
    showPhoto: false,
    photoObject: {
      groupId: null,
      photoIds: [],
    },
    showFile: false,
    fileObject: {
      fileId: null,
      fileName: null,
      groupId: null,
    },
    showFieldTextModal: false,
    showFieldToolInfoModal: false,
    textAreaObj: {
      group: null,
      stroke: null,
      fill: null,
      text: null,
      fontSize: null,
      groupId: null,
    },
    toolInfo: {
      group: null,
    },
    copyToolInfo: {},
    calibrationList: [],
    activeCalibration: {
      uuid: 1,
      name: '1',
      type: 'standard',
      value: 1,
    },
    role: {
      name: '',
      colour_code: '',
    },
    highLightPages: [],
    drawingRightClickMenu: false,
    drawingRightClickInfo: {
      group: {},
      type: '',
      event: null,
      stageX: 0,
      stageY: 0,
    },
  },
  getters: {
    getVisualData: state => state.visualData,
    getActiveCalibration: state => state.activeCalibration,
    getActiveCalibrationName: state => state.activeCalibration.name,
    GET_PLAN_FOLDER: state => state.folderIds.Plans,
    GET_PROJECT_INFO: state => state.projectInfo,
    GET_PHOTOS_FOLDER: state => state.folderIds.Photos,
    GET_FILES_FOLDER: state => state.folderIds.Files,
    GET_SPECIFICATIONS_FOLDER: state => state.folderIds.Specifications,
    GET_FIELD_ACTIVITY_BAR: state => state.showActivityBar,
    getIsStartDrawing: state => state.isStartDrawing,
    getToolType: state => state.toolType,
    getPhotoObject: state => state.photoObject,
    showPhotoModal: state => state.showPhoto,
    getFileObject: state => state.fileObject,
    showFileModal: state => state.showFile,
    showFieldTextModal: state => state.showFieldTextModal,
    showFieldToolInfoModal: state => state.showFieldToolInfoModal,
    getTextareaFormData: state => state.textAreaObj,
    GET_ROLE_AND_COLOR: state => state.role,
    GET_COLOR: state => state.role.colour_code,
    getSelectedObjectName: state => state.selectedObjectName,
    GET_IS_SHOW_COLOR: state => state.showColorBox,
    GET_FIELD_TOOL_INFO: state => state.toolInfo,
    GET_COPY_TOOL_INFO: state => state.copyToolInfo,
    GET_HIGH_LIGHT_PAGES: state => state.highLightPages,
    getCalibrationList: state => state.calibrationList,
    GET_DRAWING_RIGHT_CLICK_MENU: state => state.drawingRightClickMenu,
    GET_DRAWING_RIGHT_CLICK_INFO: state => state.drawingRightClickInfo,
  },
  mutations: {
    SET_FOLDER_IDS: (state, payload) => {
      state.folderIds = payload
    },
    SET_PROJECT_INFO: (state, payload) => {
      state.projectInfo = payload
    },
    SET_ACTIVE_CALIBRATION(state, payload) {
      state.activeCalibration = payload
    },
    UPDATE_CALIBRATION_LIST(state, payload) {
      if (!state.calibrationList.find(i => i.uuid === payload.uuid)) {
        state.calibrationList.push(payload)
      }
    },
    SET_CALIBRATION_LIST(state, payload) {
      state.calibrationList = []
      payload.forEach(c => {
        if (!state.calibrationList.find(i => i.uuid === c.uuid)) {
          state.calibrationList.push(c)
        }
      })
    },
    SET_COLOR: (state, payload) => {
      state.role.colour_code = payload
    },
    SET_DRAWING_RIGHT_CLICK_MENU: (state, payload) => {
      state.drawingRightClickMenu = payload
    },
    SET_RIGHT_CLICK_DRAWING_INFO: (state, payload) => {
      state.drawingRightClickInfo = payload
    },

    SET_OPEN_PHOTO(state, payload) {
      state.showPhoto = true
      state.photoObject = payload
    },
    SET_SHOW_PHOTO(state, payload) {
      state.showPhoto = payload
    },
    SET_OPEN_FILE(state, payload) {
      console.log('payload >> ', payload)
      state.showFile = true
      state.fileObject = payload
    },
    SET_SHOW_FILE(state, payload) {
      state.showFile = payload
    },
    SET_FIELD_ACTIVITY_BAR: (state, payload) => {
      state.showActivityBar = payload
    },
    SET_TOOL_TYPE(state, payload) {
      state.toolType = payload
    },
    SET_IS_START_DRAWING(state, payload) {
      state.isStartDrawing = payload
    },
    SET_VISUAL_STATE: (state, payload) => {
      state.visualData = payload.data
    },
    SET_COMPARE_VISUAL_DATA: (state, payload) => {
      state.compareVisualData[payload.version] = payload.data
    },
    RESET_VISUAL_STATE: state => {
      state.visualData = null
      state.visualCount = 0
      state.compareVisualData = []
    },
    RESET_STATE(state) {
      state.calibrationList = []
      state.toolType = 0
      state.isStartDrawing = false
      state.showColorBox = false
      state.selectedObjectName = null
      state.activeCalibration = {
        uuid: 1,
        name: '1',
        type: 'standard',
        value: 1,
      }
    },
    setShowColorBox: (state, payload) => {
      state.showColorBox = payload
    },
    setIsSelectObject: (state, payload) => {
      state.isSelectObject = payload
    },
    SET_OBJECT_NAME(state, payload) {
      state.selectedObjectName = payload
    },
    SET_SHOW_TEXT_MODAL: (state, payload) => {
      state.showFieldTextModal = payload
    },
    SET_SHOW_TOOL_INFO_MODAL: (state, payload) => {
      state.showFieldToolInfoModal = payload
    },
    SET_OPEN_TEXTAREA_MODAL(state, payload) {
      state.showFieldTextModal = true
      state.textAreaObj = payload
    },
    SET_OPEN_FIELD_TOOL_INFO_MODAL(state, payload) {
      state.showFieldToolInfoModal = true
      state.toolInfo = payload
    },
    SET_COPY_FIELD_TOOL_INFO(state, payload) {
      state.copyToolInfo = payload
    },

    UPDATE_TEXTAREA_FIELD(state, { key, value }) {
      state.textAreaObj[key] = value
    },
    SET_ROLE(state, payload) {
      state.role = payload
    },
    SET_HIGH_LIGHT_PAGES: (state, payload) => {
      state.highLightPages = payload
    },
  },
  actions: {
    SET_FOLDER_IDS_STATE: ({ commit }, payload) => {
      commit('SET_FOLDER_IDS', payload)
    },
    SET_PROJECT_INFO_STATE: ({ commit }, payload) => {
      commit('SET_PROJECT_INFO', payload)
    },
    SET_ROLE_STATE({ commit }, payload) {
      if (payload && Object.keys(payload).length) {
        payload.colour_code = payload.colour_code || '#ff0000'
        commit('SET_ROLE', payload)
      } else {
        commit('SET_ROLE', {
          name: 'Default',
          colour_code: '#ff0000',
        })
      }
    },
    FETCH_VISUAL_DATA: ({ commit }, payload) => {
      commit('RESET_VISUAL_STATE')
      return new Promise(resolve => {
        api
          .findByParams(`${payload.component}`, {
            params: payload.filter,
            cancelToken: payload.cancelToken,
          })
          .then(({ data }) => {
            if (data.success && data.data) {
              if (payload.filter) {
                const commitPayload = data
                commitPayload.version = payload.filter.version
                commit('SET_COMPARE_VISUAL_DATA', commitPayload)

                return
              }
              commit('SET_VISUAL_STATE', data)
            }
          })
          .catch(error => {
            commit('RESET_VISUAL_STATE')
            if (error.response?.status !== 404 && error.response?.status !== 400) {
              Toaster.error("We've encountered some error to fetch the drawing for this page, Please contact to support team!!", "error")
            }
          })
          .finally(() => {
            resolve()
          })
      })
    },
  },
}
